import { useCallback, useMemo } from 'react';

import { useHowToApproach } from './useHowToApproach.js';
import { useItemParam } from './useItemParam.js';

/**
 * Everything the profile page needs for How to approach (CT-5714), so the page
 * only wires it: the card (fetched ONCE per profile, scoped to the record) and
 * `openSource`, which opens a row's trait or insight in the profile slide-out
 * through `?item=` (keeping the other params, so Back closes it).
 *
 * @param {object} options
 * @param {string} options.entityType
 * @param {string} options.entityId
 */
export function useProfileHowToApproach({ entityType, entityId } = {}) {
  const { approach, loading, error, refetch, refresh } = useHowToApproach({ entityType, entityId });
  const { openItem } = useItemParam();
  const openSource = useCallback((source) => openItem(source.kind, source.id), [openItem]);

  return useMemo(
    () => ({ approach, loading, error, refetch, refresh, openSource }),
    [approach, loading, error, refetch, refresh, openSource],
  );
}

export default useProfileHowToApproach;
